import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import {styled} from "@mui/material";

export const StyledDatePicker = styled(DesktopDatePicker)(({ theme }) => ({
    boxShadow: theme.shadows[25],
    background: 'white',
    borderRadius: 4,
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 0, 1, 1),
        transition: theme.transitions.create('width'),
        width: '100%',
        height: 24
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 0
    }
}));

// El adaptador de date-fns considera que `undefined` es una fecha valida -lo convierte en
// "ahora"- pero despues no lo puede formatear. MUI arma el aria-label del boton con
// `openDatePickerDialogue`, que solo se protege de `null`:
//
//     value !== null && utils.isValid(value) ? utils.format(value, 'fullDate') : '...'
//
// Con `undefined` pasa las dos condiciones y `format` tira "RangeError: Invalid time
// value", que se lleva la pantalla entera. Aca ese texto pasa a ser fijo: es una etiqueta
// de accesibilidad para el boton del calendario, no informacion que el usuario lea.
export const PICKER_LOCALE_TEXT = {
    openDatePickerDialogue: () => 'Elegir fecha',
    openTimePickerDialogue: () => 'Elegir hora'
};
